import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'eco-no-data-placeholder',
    templateUrl: './no-data-placeholder.component.html',
    styleUrls: ['./no-data-placeholder.component.scss'],
    imports: [MatIcon]
})
export class NoDataPlaceholderComponent {
    @Input() icon = 'help_outline';
    @Input() text = 'No data available';
}
